import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { Button } from './Button';
import { Modal, ModalTitle, ModalBody, ModalFooter } from './Modal';
export function ConfirmDialog({
  open,
  onClose,
  onConfirm,
  title = 'Are you sure?',
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  destructive = false,
  loading = false,
  className,
}) {
  return (
    <Modal open={open} onClose={onClose} size="sm" className={className}>
      <ModalTitle>
        <span className="flex items-center gap-2">
          {destructive && (
            <AlertTriangle size={20} className="text-danger-500" aria-hidden="true" />
          )}
          {title}
        </span>
      </ModalTitle>
      <ModalBody>
        <p>{message}</p>
      </ModalBody>
      <ModalFooter>
        <Button variant="outline" size="sm" onClick={onClose} disabled={loading}>
          {cancelLabel}
        </Button>
        <Button
          variant={destructive ? 'danger' : 'primary'}
          size="sm"
          onClick={onConfirm}
          loading={loading}
        >
          {confirmLabel}
        </Button>
      </ModalFooter>
    </Modal>
  );
}
